/**
 * Utility functions for FlyDay component
 */

/**
 * Convert date from minus format to dot format
 */
export const convertDateMinusToDot = (date) => {
  if (date === null) return null;
  if (date instanceof Date) {
    return 'Date';
  } else if (typeof date === 'string') {
    return date.replaceAll('-', '.');
  }
  return null;
};

export const ACTIVE_TYPES = {
  GLIDER: 'glider',
  FIRST_PILOT: 'first'
};

